function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

/*============================================================================
  ColorsSlider
==============================================================================*/
class ColorsSlider extends HTMLElement {
  constructor() {
    super();
    new Splide(".colors-carousel", {
      type: "loop",
      perPage: 4,
      gap: 20,
      autoplay: true,
      padding: "10%",
      perMove: 1,
      speed: 10000,
      rewindSpeed: 10000,
      dots: false,
      interval: 1000,
      arrows: false,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 2.5,
        },
        768: {
          perPage: 2.5,
        },
        640: {
          perPage: 1.5,
        },
        480: {
          perPage: 1.5,
        },
      },
    }).mount();
  }
}
customElements.define("colors-slider", ColorsSlider);

/*============================================================================
  Video Component
==============================================================================*/
class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector(".modal-video");
    this.btnPlay = this.querySelector("#btn-play");
    this.video = this.querySelector(".video-modal");
    this.close = this.querySelector(".close");
    this._bindEvents();
  }

  _bindEvents() {
    this.btnPlay.addEventListener("click", (e) => {
      e.preventDefault();
      this._openModal();
      this.playVideo();
    });

    this.close.addEventListener("click", (e) => {
      e.preventDefault();
      this._closeModal();
    });
  }

  _openModal() {
    this.modal.classList.remove("hidden");
    // overflow hidden on body
    document.body.classList.add("overflow-hidden");

    document.getElementById("announcement--container").classList.add("hidden");
    document.getElementById("shopify-section-header").classList.add("hidden");
    document.getElementById("bg-hidden").classList.add("hidden");
    //window.scrollHtml.stop();
    this._bindModalEvents();
  }

  _bindModalEvents() {
    this.modal.addEventListener("click", (e) => {
      e.preventDefault();
      this._closeModal();
    });
  }

  _closeModal() {
    this.pauseVideo();
    this.modal.classList.add("hidden");
    // overflow hidden on body
    document.body.classList.remove("overflow-hidden");
    //window.scrollHtml.start();

    document
      .getElementById("announcement--container")
      .classList.remove("hidden");
    document
      .getElementById("shopify-section-header")
      .classList.remove("hidden");
    document.getElementById("bg-hidden").classList.remove("hidden");
  }

  playVideo() {
    this.video.play();
  }

  pauseVideo() {
    this.video.pause();
  }
}

customElements.define("video-component", VideoComponent);

/*============================================================================
  FAQ Component
==============================================================================*/
class FaqComponent extends HTMLElement {
  constructor() {
    super();
    this.questions = this.querySelectorAll(".question");

    this._bindEvents();
  }

  _bindEvents() {
    this.questions.forEach((question) => {
      question.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._toggleAnswer(question);
      });
    });
  }

  _toggleAnswer(question) {
    question.classList.toggle("active");
  }
}

customElements.define("faq-component", FaqComponent);

/*============================================================================
  HotSpots
==============================================================================*/
class HotSpots extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.buttons = this.querySelectorAll("[data-button]");
    this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]");
    this.blockContainer = this.querySelector("[data-block-container]");

    this._bindEvents();
  }

  _bindEvents() {
    this.buttons.forEach((button) => {
      const id = button.dataset.button;

      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._showContent(id);
      });
    });
  }

  /* Toggle sidebar content */
  _showContent(id) {
    // Hide all hotspotBlock
    // Show the hotspotBlock with the id
    this.hotspotBlocks.forEach((block) => {
      if (block.dataset.hotspotBlock === id) {
        block.classList.add("active");
        block.querySelector("button").addEventListener("click", () => {
          block.classList.remove("active");
        });
      } else {
        block.classList.remove("active");
      }
    });
  }

  _setupQuickShop() {
    if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
      // Ensure we are utilizing the right version of QuickShop based off of theme
      if (typeof theme.QuickShop === "function") {
        new theme.QuickShop(this.blockContainer);
      } else if (typeof theme.initQuickShop === "function") {
        theme.initQuickShop();
      }

      if (typeof theme.QuickAdd === "function") {
        new theme.QuickAdd(this.blockContainer);
      }
    }
  }
}

customElements.define("hot-spots", HotSpots);

/*============================================================================
  Fixed Newsletter Bar
==============================================================================*/
class fixedNewsletterBar extends HTMLElement {
  constructor() {
    super();
    this.contactForms = document.querySelectorAll("form");
    this._init();
  }

  _init() {
    document.addEventListener("scroll", (event) => {
      let showBarCount = 0;
      this.contactForms.forEach(function (contactForm) {
        var contactFormPosition = contactForm.getBoundingClientRect();
        var contactFormTop = contactFormPosition.top;
        var contactFormBottom = contactFormPosition.bottom;

        var windowHeight = window.innerHeight;
        var contactFormVisible =
          contactFormTop >= 0 &&
          contactFormBottom <= windowHeight &&
          contactFormTop <= windowHeight &&
          contactFormBottom >= 0;

        if (!contactFormVisible) {
          showBarCount++;
        }
      });
      if (showBarCount === this.contactForms.length - 2) {
        this.classList.add("hidden");
        this.classList.remove("block");
      } else {
        this.classList.remove("hidden");
        this.classList.add("block");
      }
    });
  }
}

customElements.define("fixed-newsletter-bar", fixedNewsletterBar);

// Ouvrir la modal au clic
document.body.addEventListener("click", function (e) {
  var target = e.target;
  if (!target.classList.contains("button__action")) return;
  e.preventDefault();
  var buttonFor = target.getAttribute("for");
  var selector = target.getAttribute("open-selector");

  if (selector) {
    document.querySelector(selector).classList.add("opened");
  }
  if (
    selector === "#filter-collection-drawer" ||
    selector === "#cart__drawer"
  ) {
    document
      .getElementById("page__overlay--navigation")
      .classList.add("opened");
  } else {
    document.getElementById("page__overlay").classList.add("opened");
  }

  if (buttonFor === "drawer" && selector) {
    document
      .getElementById("page__overlay--navigation")
      .setAttribute("for", "drawer");
  } else if (buttonFor === "drawer-cart" && selector) {
    if (
      document
        .getElementById("filter-collection-drawer")
        .classList.contains("opened")
    ) {
      document
        .getElementById("filter-collection-drawer")
        .classList.remove("opened");
    }
    document
      .getElementById("page__overlay--navigation")
      .setAttribute("for", "drawer");
    setTimeout(function () {
      document
        .getElementById("drawer__cart--exta-infos")
        .classList.add("opened");
    }, 350);
  } else if (buttonFor === "accordeon") {
    var isActive = false;
    if (target.classList.contains("active")) {
      isActive = true;
    }
    if (target.classList.contains("link--item-button")) {
      var activeLink = document.querySelector(".link--item-button.active");
      activeLink.nextElementSibling.classList.remove("opened");
      activeLink.nextElementSibling.style.display = "none";
      activeLink.querySelector(".plus__icon").classList.remove("opened");
      activeLink.classList.remove("active");
    } else if (target.classList.contains("sub__link--item-button")) {
      var activeSubLink = document.querySelector(
        ".sub__link--item-button.active"
      );
      activeSubLink.nextElementSibling.classList.remove("opened");
      activeSubLink.nextElementSibling.style.display = "none";
      activeSubLink.querySelector(".plus__icon").classList.remove("opened");
      activeSubLink.classList.remove("active");
    }

    if (!isActive) {
      target.classList.toggle("active");
      target.querySelector(".plus__icon").classList.toggle("opened");
      target.nextElementSibling.classList.add("opened");
      target.nextElementSibling.style.display = "block";
    }
  } else if (buttonFor === "modal" && selector) {
    document.getElementById("page__overlay").setAttribute("for", "modal");
  }
});

// Fermer la modal au clic sur la croix
document.body.addEventListener("click", function (e) {
  var target = e.target;
  if (!target.classList.contains("close")) return;
  e.preventDefault();
  var closeFor = target.getAttribute("for");

  document.getElementById("page__overlay").classList.remove("opened");
  document
    .getElementById("page__overlay--navigation")
    .classList.remove("opened");
  document.getElementById("page__overlay").setAttribute("for", "");
  document.getElementById("page__overlay--navigation").setAttribute("for", "");

  if (closeFor === "drawer") {
    document.querySelector(".drawer").classList.remove("opened");
  } else if (closeFor === "modal") {
    document.querySelector(".modal").classList.remove("opened");
    if (document.querySelector(".modal-loader")) {
      document.querySelector(".modal-loader").style.display = "block";
    }
    if (document.querySelector(".modal-has-to-load")) {
      document.querySelector(".modal-has-to-load").style.display = "none";
    }
  }
});

// Clic en dehors de la 'modal'
document
  .getElementById("page__overlay")
  .addEventListener("click", function (e) {
    e.preventDefault();
    var overlayFor = this.getAttribute("for");

    this.classList.remove("opened");
    document
      .getElementById("page__overlay--navigation")
      .classList.remove("opened");
    this.setAttribute("for", "");
    document
      .getElementById("page__overlay--navigation")
      .setAttribute("for", "");

    if (overlayFor === "drawer") {
      document.querySelector(".drawer").classList.remove("opened");
    } else if (overlayFor === "modal") {
      document.querySelector(".modal").classList.remove("opened");
      document.querySelector(".modal-loader").style.display = "block";
      document.querySelector(".modal-has-to-load").style.display = "none";
    }
  });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class VariantSelectsCustom extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("variant-changed", (event) => {
      event.preventDefault();
      console.log("change", event);

      this.onVariantChange(event);
    });
  }

  onVariantChange(event) {
    this.updateMasterId(event);
    this.renderProductInfo();
    this.updateVariantInput();
    this.scrollToProduct();
  }

  scrollToProduct() {
    console.log("scrollToProduct");
    console.log("window.innerWidth", window.innerWidth);
    if (window.innerWidth < 800) {
      const product = document.getElementById("slider--product");
      const headerHeight =
        document.querySelector(".header-group")?.offsetHeight || 0;
      const offset = 20;

      // Calculer la position exacte de l'élément par rapport au haut de la page
      const elementPosition =
        product.getBoundingClientRect().top + window.pageYOffset;

      // Soustraire la hauteur du header et l'offset pour obtenir la position finale
      const offsetPosition = elementPosition - 50 - offset;

      console.log("offsetPosition", offsetPosition);

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }

  updateMasterId(event) {
    this.currentVariant = event.detail.variant;
  }

  renderGallery(id) {
    new Splide("#" + id, {
      pagination: true,
      arrows: true,
      perMove: 1,
      mediaQuery: "min",
      breakpoints: {
        1201: {
          destroy: true,
        },
        1200: {
          perPage: 1,
        },
      },
    }).mount();
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destination = document.getElementById(`variant_status`);
        const source = html.getElementById(`variant_status`);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const stickyButtonDestination = document.querySelector(`sticky-button`);

        const stickyButtonSource = html.querySelector(`sticky-button`);

        if (stickyButtonSource && stickyButtonDestination) {
          stickyButtonDestination.innerHTML = stickyButtonSource.innerHTML;
          stickyButtonDestination.init();
        }

        //price
        const destinationPrice = document.getElementById(
          `price-${this.dataset.section}`
        );
        const sourcePrice = html.getElementById(
          `price-${this.dataset.section}`
        );

        if (sourcePrice && destinationPrice)
          destinationPrice.innerHTML = sourcePrice.innerHTML;

        const destinationImages = document.querySelector(`media-gallery`);
        const sourceImages = html.querySelector(`media-gallery`);

        if (sourceImages && destinationImages) {
          destinationImages.innerHTML = sourceImages.innerHTML;
          destinationImages.querySelectorAll("video").forEach((video) => {
            // auto play videos
            video.play();
          });
        }

        const productModalDestination = document.querySelector(`product-modal`);
        const productModalSource = html.querySelector(`product-modal`);

        if (productModalSource && productModalDestination) {
          productModalDestination.innerHTML = productModalSource.innerHTML;
          productModalDestination.init();
        }

        this.renderGallery(`MediaGallery-${this.dataset.section}`);
      });
  }
}

customElements.define("variant-selects-custom", VariantSelectsCustom);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) => {
      if (mediaGallery.classList.contains("media-gallery")) {
        mediaGallery.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        );
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
  play() {
    this.querySelector("video").play();
  }
}

customElements.define("deferred-media", DeferredMedia);

/*============================================================================
  Logo List Component
==============================================================================*/
class LogoListComponent extends HTMLElement {
  constructor() {
    super();
    new Splide("." + this.getAttribute("data-slide"), {
      perPage: 5,
      pagination: false,
      arrows: false,
      autoplay: true,
      type: "loop",
      perMove: 1,
      interval: 1500,
      breakpoints: {
        500: {
          perPage: 2,
        },
      },
    }).mount();
  }
}
customElements.define("logo-list", LogoListComponent);

/*============================================================================
  Campaign Countdown
==============================================================================*/
class CampaignCountdown extends HTMLElement {
  constructor() {
    super();
    this.timer = setInterval(() => this.showRemainingCampaign(), 1000);
  }
  showRemainingCampaign() {
    let date = this.getAttribute("data-end")?.split("-");
    let end = new Date(date[2], date[0] - 1, date[1]);
    console.log("end", end, this.getAttribute("data-end"));
    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
    var now = new Date();
    var distance = end - now;

    var days = Math.floor(distance / _day);
    var hours = Math.floor((distance % _day) / _hour);
    var minutes = Math.floor((distance % _hour) / _minute);
    var seconds = Math.floor((distance % _minute) / _second);

    if (distance < 0) {
      days = 0o0;
      hours = 0o0;
      minutes = 0o0;
      seconds = 0o0;
    }

    this.querySelector("#campaign-days").children[0].innerHTML = days;
    this.querySelector("#campaign-hour").children[0].innerHTML = hours;
    this.querySelector("#campaign-mins").children[0].innerHTML = minutes;
    this.querySelector("#campaign-secs").children[0].innerHTML = seconds;
  }
}
customElements.define("campaign-countdown", CampaignCountdown);

/*============================================================================
  Videos List Component
==============================================================================*/
class VideosListComponent extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.currentIndex = 0;
    this.sectionId = this.getAttribute("data-slide");
    this.numberVideos = parseInt(this.getAttribute("data-count"));

    this.videos = this.querySelectorAll("video");
    new Splide(".splide-videos-list--" + this.getAttribute("data-slide"), {
      perPage: 4,
      pagination: true,
      arrows: true,
      perMove: 1,
      padding: {
        right: 200,
      },
      drag: true,
      type: "loop",
      breakpoints: {
        1100: {
          perPage: 3,
        },
        900: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        },
      },
    }).mount();
    this.slider = new Splide(
      ".splide-videos-list-zoom--" + this.getAttribute("data-slide"),
      {
        drag: true,
        perPage: 1,
        pagination: true,
        arrows: true,
        perMove: 1,
      }
    ).mount();

    this.slider.on("move", (index) => {
      console.log(index);
      this.currentIndex = index;

      this.video = this.querySelector(
        `.video-${this.sectionId}-${this.currentIndex}`
      );

      this.videos.forEach((video) => video.pause());

      this.video.play();
    });

    this.close = this.querySelector(".close");

    this.close.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeVideosSlider();
    });

    this.querySelectorAll(".splide-video").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openVideosSlider(btn);
      });
    });

    this.sliderVideos = this.querySelector(".splide-videos-list-zoom");

    this.videos.forEach((video) => {
      this.listernerVideo(video);
    });
  }

  openVideosSlider(btn) {
    this.currentIndex = parseInt(btn.dataset.index);

    this.sliderVideos.classList.add("active");
    this.slider.go(this.currentIndex);
    this.video = this.querySelector(
      `.video-${this.sectionId}-${this.currentIndex}`
    );

    if (this.currentIndex === 0) {
      this.video.play();
    }
  }

  closeVideosSlider() {
    this.sliderVideos.classList.remove("active");
    this.querySelectorAll("video").forEach((video) => video.pause());
  }

  listernerVideo(video) {
    video.addEventListener("ended", (e) => {
      this.currentIndex = parseInt(this.currentIndex) + 1;
      console.log(this.currentIndex, this.numberVideos);
      if (this.currentIndex >= this.numberVideos) {
        this.currentIndex = 0;
      }
      this.slider.go(this.currentIndex);
      console.log(`.video-${this.sectionId}-${this.currentIndex}`);
      this.video = this.querySelector(
        `.video-${this.sectionId}-${this.currentIndex}`
      );
      this.videos.forEach((video) => video.pause());

      this.video.play();
    });
  }
}
customElements.define("videos-list", VideosListComponent);

class NewsletterFormComponent extends HTMLElement {
  constructor() {
    super();
    this.already = document.querySelector("#already");
    var live_url = window.location.href;
    var result = live_url.includes("form_type=customer");
    if (result) {
      this.already.classList.remove("hidden");
    }
  }
}
customElements.define("newsletter-form", NewsletterFormComponent);

class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.slider = new Splide("#" + this.id, {
      pagination: true,
      arrows: true,
      perMove: 1,
      mediaQuery: "min",
      breakpoints: {
        1201: {
          destroy: true,
        },
        1200: {
          perPage: 1,
        },
      },
    }).mount();
  }

  slideTo(index) {
    this.slider.go(index);
  }
}

customElements.define("media-gallery", MediaGallery);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.sectionId = this.getAttribute("data-id");
        this.productSlider = document.querySelector("media-gallery");
        this.slider = new Splide(
          `#ModalContent-${this.getAttribute("data-id")}`,
          {
            pagination: true,
            arrows: true,
            perMove: 1,
          }
        ).mount();

        this.close = this.querySelector(".product-media-modal__toggle");

        this.close.addEventListener("click", (e) => {
          e.preventDefault();
          this.hide();
        });

        this.videos = this.querySelectorAll("deferred-media");

        this.slider.on("move", (index) => {
          this.currentIndex = index + 1;

          if (this.currentIndex < 10) {
            this.currentIndex = `0${index + 1}`;
          }
          this.playVideo(this.currentIndex);
        });
      }

      hide() {
        if (this.productSlider) this.productSlider.slideTo(this.slider.index);
        super.hide();
      }
      playVideo(index) {
        this.video = this.querySelector(
          `#ModalContent-${this.sectionId}-slide${index}`
        );
        console.log("this.video children", this.video.children[0]);
        //await 0.5s
        setTimeout(() => {
          if (this.video) {
            console.log("this.video", this.video.children[0].nodeName);
            if (
              this.video.children[0] === "DEFERRED-MEDIA" ||
              this.video.children[0].nodeName === "VIDEO"
            ) {
              //this.video.children[0]?.loadContent();
              this.video.children[0]?.play();
            }
          }
        }, 500);
      }

      show(index) {
        console.log("index, ", index);
        this.slider.go(parseInt(index - 1));
        super.show();
        this.playVideo(index < 10 ? `0${index}` : index);
      }
    }
  );
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      console.log("modal", modal);
      if (modal) modal.show(this.dataset.index);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class Reassurance extends HTMLElement {
  constructor() {
    super();
    this.textElements = this.querySelectorAll("reassurance-component .text");
    this.dotElements = this.querySelectorAll("reassurance-component .dot");
    this.currentIndex = 0;
    this.toggleActiveElements();
    setInterval(this.toggleActiveElements.bind(this), 3000);
  }

  toggleActiveElements() {
    this.textElements.forEach((element) => {
      element.classList.remove("active");
    });

    if (this.dotElements) {
      this.dotElements.forEach((element) => {
        element.classList.remove("active");
      });
      this.dotElements[this.currentIndex]?.classList.add("active");
    }

    this.textElements[this.currentIndex].classList.add("active");

    this.currentIndex = (this.currentIndex + 1) % this.textElements.length;
  }
}
customElements.define("reassurance-component", Reassurance);

class upsellDrawerSlider extends HTMLElement {
  constructor() {
    super();
    if (this.children.length > 0) {
      this.splide = new Splide(
        "#upsell-drawer-slider-" + this.getAttribute("data-slide"),
        {
          perPage: 2,
          padding: {
            right: "5rem",
          },
          width: "100%",
          drag: true,
          arrows: false,
          breakpoints: {
            470: {
              perPage: 1,
              padding: {
                right: "20rem",
              },
            },
            380: {
              perPage: 1,
              padding: {
                right: "15rem",
              },
            },
            300: {
              perPage: 1,
              padding: {
                right: "1rem",
              },
            },
          },
        }
      ).mount();
    }
  }
}

customElements.define("upsell-drawer-slider", upsellDrawerSlider);

class InflatedDelivery extends HTMLElement {
  constructor() {
    super();
    this.alreadyDelete = false;
    this.initializeProperties();
    this.registerEventListeners();
    this.checkInitialInflatedValue();
  }

  initializeProperties() {
    this.lineItemId = this.getAttribute("key");
    this.inflatedDeliveryKey = this.getAttribute("inflated_delivery_product");
    this.quantity = parseInt(this.getAttribute("quantity"), 10);
    this.currentInflatedQuantity = parseInt(
      this.getAttribute("current_inflated_quantity"),
      10
    );
    this.isActivated = this.getAttribute("is-active") === "true";
    this.currentInflatedValue = this.getAttribute("current_inflated_value");
    this.cart = document.querySelector("cart-drawer");
    this.deliveryButton = this.querySelector(".bloated");
  }

  registerEventListeners() {
    this.deliveryButton.addEventListener(
      "click",
      this.handleDeliveryClick.bind(this)
    );
  }

  checkInitialInflatedValue() {
    if (this.currentInflatedValue != this.currentInflatedQuantity) {
      this.updateCart({
        type: "inflatedDelivery",
        quantity: 0,
        action: "remove",
      });
    }
  }

  async handleDeliveryClick(e) {
    e.preventDefault();
    const action = this.isActivated;
    const quantityAction = this.isActivated ? "remove" : "add";
    console.log("quantityAction", quantityAction);
    console.log("quantityAction", this.isActivated);

    await this.updateCart({ type: "product", value: action });
    setTimeout(async () => {
      await this.updateCart({
        type: "inflatedDelivery",
        quantity: this.quantity,
        action: quantityAction,
        refresh: true,
      });
    }, 300);

    this.isActivated = !this.isActivated;
  }

  async updateCart({
    type,
    value = null,
    quantity = 0,
    action = "",
    refresh = false,
  }) {
    let body;
    if (type === "product") {
      body = JSON.stringify({
        id: this.lineItemId,
        quantity: this.quantity,
        properties: !value ? { Livraison_gonflée: "Oui" } : {},
      });
    } else if (type === "inflatedDelivery") {
      const updatesQuantity =
        action === "add"
          ? this.currentInflatedQuantity + quantity
          : this.currentInflatedQuantity - quantity;
      body = JSON.stringify({
        updates: { [this.inflatedDeliveryKey]: updatesQuantity },
      });
    }

    const url =
      type === "product" ? routes.cart_change_url : routes.cart_update_url;
    const sections = this.cart
      .getSectionsToRender()
      .map((section) => section.id);

    try {
      const response = await fetch(url, {
        ...fetchConfig(),
        body: JSON.stringify({
          ...JSON.parse(body), // Parse the body JSON to merge with sections data
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (this.cart && refresh) this.cart.renderContents(data);
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }
}

customElements.define("inflated-delivery", InflatedDelivery);

class StickyButton extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Initialize base elements
    this.addToCart = this.querySelector("#add-to-cart");
    this.backInStock = this.querySelector("#back-in-stock");
    this.originalAddToCart = document.querySelector(
      "button[name='add'].product-form__submit"
    );
    this.originalBackInStock = document.querySelector(
      "[data-bis-trigger-id='back-in-stock']"
    );

    // Add button event listeners
    this.setupButtonListeners();

    // Setup chat bot observer with delay to ensure it's loaded
    this.setupChatBotObserver();
  }

  setupButtonListeners() {
    if (this.addToCart) {
      this.addToCart.addEventListener("click", () =>
        this.originalAddToCart?.click()
      );
    }
    if (this.backInStock) {
      this.backInStock.addEventListener("click", () =>
        this.originalBackInStock?.click()
      );
    }
  }

  setupChatBotObserver() {
    // Check periodically for chat bot existence for up to 10 seconds
    let attempts = 0;
    const maxAttempts = 20; // 20 attempts * 500ms = 10 seconds

    const checkChatBot = setInterval(() => {
      const chatBot = document.querySelector("#gorgias-chat-container");
      attempts++;

      if (chatBot || attempts >= maxAttempts) {
        clearInterval(checkChatBot);
        if (chatBot) {
          this.initializeIntersectionObserver();
          // Initial visibility check
          this.updateChatBotVisibility();
        }
      }
    }, 500);

    // Observe DOM changes to detect late chat bot addition
    const chatBotObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.id === "gorgias-chat-container") {
            this.initializeIntersectionObserver();
            this.updateChatBotVisibility();
          }
        });
      });
    });

    chatBotObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  toggleChatBot(show) {
    const chatBot = document.querySelector("#gorgias-chat-container");
    if (chatBot) {
      chatBot.style.display = show ? "none" : "block";
      // Add class for smooth transition if needed
      chatBot.classList.toggle("hidden", !show);
    }
  }

  updateChatBotVisibility() {
    const addToCartButton = document.querySelector(
      "button[name='add'].product-form__submit"
    );
    if (!addToCartButton) return;

    const buttonRect = addToCartButton.getBoundingClientRect();
    const isVisible =
      buttonRect.top < window.innerHeight && buttonRect.bottom >= 0;

    // Inverse logic: show chat bot when button is not visible
    this.toggleChatBot(isVisible);

    // Update sticky bar classes
    this.classList.toggle("md:translate-y-[0%]", !isVisible);
    this.classList.toggle("translate-y-[100%]", isVisible);
  }

  initializeIntersectionObserver() {
    // Observe both add to cart and back in stock buttons
    const addToCartButton = document.querySelector(
      "button[name='add'].product-form__submit"
    );
    const backInStockButton = document.querySelector(
      "[data-bis-trigger-id='back-in-stock']"
    );

    // If neither button exists, return early
    if (!addToCartButton || !backInStockButton) return;

    // Use the button that exists (add to cart has priority if both exist)
    let targetToObserve = addToCartButton;

    // if addToCartButton have style display none, use backInStockButton
    if (addToCartButton.style.display === "none") {
      targetToObserve = backInStockButton;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const isVisible = entry.isIntersecting;
          this.classList.toggle("md:translate-y-[0%]", !isVisible);
          this.classList.toggle("translate-y-[100%]", isVisible);
          this.toggleChatBot(!isVisible);
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    observer.observe(targetToObserve);
  }
}

customElements.define("sticky-button", StickyButton);

class ReinssuranceSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.slider = new Splide(
      ".reinssurance-slider--" + this.getAttribute("data-slide"),
      {
        perPage: 3,
        perMove: 1,
        pagination: false,
        arrows: false,
        drag: true,
        autoplay: true,
        interval: 1500,
        breakpoints: {
          1400: {
            perPage: 3,
          },
          1200: {
            perPage: 1,
          },
          950: {
            perPage: 1,
          },
          767: {
            perPage: 1,
          },
        },
      }
    ).mount();
  }
}

customElements.define("reinssurance-slider", ReinssuranceSlider);

class SliderGonfler extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.slider = new Splide(
      ".slider-gonfler--" + this.getAttribute("data-slide"),
      {
        mediaQuery: "max",
        perPage: 5,
        type: "loop",
        perMove: 1,
        arrows: false,
        autoplay: true,
        interval: 1500,
        breakpoints: {
          1400: {
            perPage: 5,
          },
          1200: {
            perPage: 4,
            pagination: true,
          },
          950: {
            perPage: 3,
          },
          500: {
            perPage: 2,
          },
        },
      }
    ).mount();
  }
}

customElements.define("slider-gonfler", SliderGonfler);

class HighLightedLinks extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.slider = new Splide(
      ".highlighted-link--" + this.getAttribute("data-slide"),
      {
        perPage: 1,
        arrows: false,
        gap: 10,
        pagination: false,
        perMove: 1,
        drag: true,
        padding: { left: "24px", right: "100px" },
      }
    ).mount();
  }
}

customElements.define("highlighted-link", HighLightedLinks);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class QuestionDrawer extends HTMLElement {
  constructor() {
    super();

    this.id = this.getAttribute("data-id");

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#QuestionDrawer-Overlay-" + this.id).addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const questionLink = document.querySelector("#Question-" + this.id);
    questionLink.setAttribute("role", "button");
    questionLink.setAttribute("aria-haspopup", "dialog");
    questionLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(questionLink);
    });
    questionLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(questionLink);
      }
    });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
  }
}

customElements.define("question-drawer", QuestionDrawer);

class FooterContainer extends HTMLElement {
  constructor() {
    super();
    this.accordeonList = this.querySelectorAll("li.extend");

    this.accordeonList.forEach((accordeon) => {
      accordeon.addEventListener("click", this.toggleAccordeon.bind(this));
    });
  }

  toggleAccordeon(event) {
    const extendedSubmenu =
      event.currentTarget.querySelector(".extended-submenu");
    const plusIcon = event.currentTarget.querySelector(
      ".nav__footer--title .plus__icon"
    );

    if (extendedSubmenu) {
      if (extendedSubmenu.style.display === "flex") {
        extendedSubmenu.style.display = "none";
      } else {
        extendedSubmenu.style.display = "flex";
      }
    }

    if (plusIcon) {
      plusIcon.classList.toggle("opened");
    }

    this.classList.toggle("active");
  }
}
customElements.define("footer-container", FooterContainer);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.update();
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.sliderItemOffset *
      this.sliderControlLinksArray.indexOf(event.currentTarget);
    this.setSlidePosition(slideScrollPosition);
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    if (this.sliderControlButtons[this.currentPage - 1]) {
      this.sliderControlButtons[this.currentPage - 1].classList.add(
        "slider-counter__link--active"
      );
      this.sliderControlButtons[this.currentPage - 1].setAttribute(
        "aria-current",
        true
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion?.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.goalAmount = parseFloat(this.getAttribute("data-goal-amount"));

    this.variantId = this.getAttribute("data-product");
    this.cartTotal = parseFloat(this.getAttribute("data-cart-total"));
    this.quantity = parseInt(this.getAttribute("data-quantity"));
    this.isActivated = this.getAttribute("data-is-activated") === "true";
    this.goalAchieved = this.getAttribute("data-goal") === "true";

    this.goalAmount2 = parseFloat(this.getAttribute("data-goal-amount-2"));
    this.variantId2 = this.getAttribute("data-product-2");
    this.quantity2 = parseInt(this.getAttribute("data-quantity-2"));
    this.isActivated2 = this.getAttribute("data-is-activated-2") === "true";
    this.goalAchieved2 = this.getAttribute("data-goal-2") === "true";

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    setTimeout(() => {
      this.checkGoal();
      this.checkGoal2();
    }, 1000);
  }

  connectedCallback() {
    this.checkGoal();
  }

  checkGoal2() {
    if (!this.isActivated2 && this.quantity2 > 0) {
      this.updateProductFromCart(this.variantId2);
      return;
    }
    if (!this.isActivated2) return;

    if (this.quantity2 > 1) {
      // Goal achieved and product is in cart, update quantity
      this.updateProductFromCart(this.variantId2, 1);
    }
    if (!this.goalAchieved2 && this.cartTotal >= this.goalAmount2) {
      // Goal achieved, add product to cart
      this.addProductToCart(this.variantId2);
    }
    if (this.goalAchieved2 && this.cartTotal < this.goalAmount2) {
      // Goal not achieved but product is in cart, remove it
      this.updateProductFromCart(this.variantId2);
    }
  }

  checkGoal() {
    if (!this.isActivated && this.quantity > 0) {
      this.updateProductFromCart(this.variantId);
      return;
    }
    if (!this.isActivated) return;

    if (this.quantity > 1) {
      // Goal achieved and product is in cart, update quantity
      this.updateProductFromCart(this.variantId, 1);
    }
    if (!this.goalAchieved && this.cartTotal >= this.goalAmount) {
      // Goal achieved, add product to cart
      this.addProductToCart(this.variantId);
    }
    if (this.goalAchieved && this.cartTotal < this.goalAmount) {
      // Goal not achieved but product is in cart, remove it
      this.updateProductFromCart(this.variantId);
    }
  }

  addProductToCart(variantId) {
    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) this.cart.renderContents(data);
      })
      .catch((error) => console.error("Error adding product to cart:", error));
  }

  updateProductFromCart(variantId, quantity = 0) {
    const body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) this.cart.renderContents(data);
      })
      .catch((error) =>
        console.error("Error removing product from cart:", error)
      );
  }
}
customElements.define("progress-bar", ProgressBar);

class ProgressBarGifts extends HTMLElement {
  constructor() {
    super();
    this.products = JSON.parse(this.getAttribute("data-products"));
    this.cart = document.querySelector("cart-drawer");
    console.log("products", this.products);
    if (this.products.length > 0) {
      this.product_1 = this.products[0];
    }
    if (this.products.length > 1) {
      this.product_2 = this.products[1];
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.checkGoal();
    }, 300);
  }

  checkGoal() {
    const itemsToAdd = [];
    if (
      this.product_1 &&
      this.product_1.should_be_added &&
      this.product_1.quantity === 0
    ) {
      itemsToAdd.push({
        id: this.product_1.id,
        quantity: 1,
      });
    }
    if (
      this.product_2 &&
      this.product_2.should_be_added &&
      this.product_2.quantity === 0
    ) {
      itemsToAdd.push({
        id: this.product_2.id,
        quantity: 1,
      });
    }
    if (
      this.product_1 &&
      this.product_1.quantity > 0 &&
      !this.product_1.should_be_added
    ) {
      this.updateProductFromCart({
        id: this.product_1.id,
        quantity: 0,
      });
    }
    if (
      this.product_2 &&
      this.product_2.quantity > 0 &&
      !this.product_2.should_be_added
    ) {
      this.updateProductFromCart({
        id: this.product_2.id,
        quantity: 0,
      });
    }
    if (itemsToAdd.length > 0) {
      this.addProductToCart({
        items: itemsToAdd,
      });
    }
  }

  addProductToCart({ items }) {
    console.log("addProductToCart", items);
    const body = JSON.stringify({
      items: items,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) this.cart.renderContents(data);
      })
      .catch((error) => console.error("Error adding product to cart:", error));
  }

  updateProductFromCart({ id, quantity }) {
    console.log("updateProductFromCart", { id, quantity });
    const body = JSON.stringify({
      id: id + "",
      quantity: quantity,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) this.cart.renderContents(data);
      })
      .catch((error) =>
        console.error("Error removing product from cart:", error)
      );
  }
}
customElements.define("progress-bar-gifts", ProgressBarGifts);
